var styles = {"header":"navkit__ChangeBusinessunitModal__header","menu":"navkit__ChangeBusinessunitModal__menu","isDisabled":"navkit__ChangeBusinessunitModal__isDisabled","itemLink":"navkit__ChangeBusinessunitModal__itemLink","icon":"navkit__ChangeBusinessunitModal__icon"};

export { styles as default };
